<template>
    <v-row>
        <template v-if="dataset.user_permissions.includes('owner_dataset')">
            <v-row class="pa-3">
                <v-subheader class="font-weight-bold subheading mt-5">
                    Share Dataset to
                </v-subheader>
                <v-col class="xs">
                    <!-- user search and invite START -->
                    <v-select
                        v-model="selectedShare"
                        :items="items"
                        item-text="name"
                        flat
                        return-object
                        label="User, groups..."
                    />
                </v-col>
                <v-col class="ml-5 xs">
                    <v-select
                        v-model="selectedPermission"
                        :items="permissions"
                        label="Select"
                        single-line
                        auto
                        :append-outer-icon="
                            selectedPermission == 'read_dataset'
                                ? 'mdi-eye-check'
                                : selectedPermission == 'read_write_dataset'
                                ? 'mdi-pencil'
                                : selectedPermission == 'owner_dataset'
                                ? 'mdi-auto-fix'
                                : ''
                        "
                        hide-details
                    />
                </v-col>
                <v-col>
                    <v-btn
                        large
                        @click.native="
                            sendInvite(selectedShare, selectedPermission)
                        "
                    >
                        <v-icon left>
                            mdi-share-variant
                        </v-icon>
                        Share
                    </v-btn>
                    <!-- user search and invite END -->
                </v-col>
            </v-row>
        </template>
        <template v-if="dataset.permissions.length > 0">
            <v-card-text>
                <h2 class="headline black--text">
                    <v-icon class="mr-1">
                        mdi-account-group
                    </v-icon>
                    Team
                </h2>
            </v-card-text>
            <v-container grid-list-lg>
                <v-row>
                    <!-- user cards START -->
                    <v-col
                        v-for="user in dataset.permissions"
                        :key="user.id"
                        class="xs"
                        sm="6"
                        md="4"
                        lg="4"
                    >
                        <user-member-card
                            :user="user"
                            :dataset="dataset"
                            :user-permissions="dataset.user_permissions"
                            type="dataset"
                            @modifyPermissions="modifyPermissions"
                        />
                        <!-- user cards END -->
                    </v-col>
                    <v-col
                        v-for="group in groupHasPermission"
                        :key="group.id"
                        cols="6"
                        md="4"
                        lg="4"
                    >
                        <group-card
                            :group="group"
                            :dataset="dataset"
                            :user-permissions="dataset.user_permissions"
                            type="dataset"
                            @modifyPermission="modifyPermissions"
                        />
                    </v-col>
                </v-row>
            </v-container>
        </template>
    </v-row>
</template>

<script>
import DatasetService from "./services/DatasetService";
import UserMemberCard from "../../../UIComponents/Cards/UserMemberCard.vue";
import NewJumbotron from "../../../UIComponents/Jumbotron.vue";
import CompanyGroupService from "@/components/Dashboard/Views/Settings/services/CompanyGroupService";
import SettingsService from "@/components/Dashboard/Views/Settings/services/SettingsService";
import GroupCard from "@/components/UIComponents/Cards/GroupCard";

export default {
    components: {
        UserMemberCard,
        NewJumbotron,
        GroupCard
    },
    props: {
        dataset: {},
        myJumbotron: {}
    },
    data: function() {
        return {
            permissions: [
                {
                    text: "Can view",
                    value: ["read_dataset"]
                },
                {
                    text: "Can edit",
                    value: ["read_write_dataset"]
                },
                {
                    text: "Can manage",
                    value: ["owner_dataset"]
                }
            ],
            selectedPermission: {},
            selectedShare: "",
            items: [],
            groups: [],
            users: [],
            datasetPermissions: this.dataset.permissions
        };
    },
    mounted() {
        this.init().then(results => {
            this.datasetPermissions;
            this.items.push(
                ...this.datasetPermissions.map(u => {
                    u.name = u.username;
                    return u;
                })
            );
            this.items.push(...this.groups);
        });
    },
    methods: {
        async init() {
            try {
                let groups = await CompanyGroupService.list_group_company(this);
                this.groups = groups;
            } catch (e) {
                this.$store.commit("push", {
                    msg:
                        "Could not fetch users and groups to share the dataset",
                    color: "error"
                });
            }
            return this.groups;
        },
        get_permission_from_codename(permission) {
            permission = permission.split("_");
            permission.splice(permission.length - 1, 1);
            permission = permission.join("_");
            return permission;
        },
        isUser(obj) {
            if ("email" in Object.keys(obj)) {
                return true;
            } else {
                return false;
            }
        },
        sendInvite(obj, permission) {
            console.log(obj);
            if (obj != null && Object.keys(permission).length !== 0) {
                if (this.isUser(obj)) {
                    DatasetService.addPermission(
                        this,
                        this.dataset,
                        obj.username,
                        permission
                    );
                } else {
                    CompanyGroupService.add_permission_group_company(
                        this,
                        obj.id,
                        permission.map(p =>
                            this.get_permission_from_codename(p)
                        ),
                        "dataset",
                        this.dataset.hmd_id
                    );
                }
            }
        },
        modifyPermissions(myObject) {
            this.$emit("modifyPermissions", myObject);
        }
    },
    computed: {
        groupHasPermission() {
            let groupPermission = this.groups.filter(g => {
                let permissions = g.permissions.filter(p =>
                    p.codename.includes("dataset")
                );
                let o_permissions = g.object_permissions.filter(
                    p =>
                        p.codename.includes("dataset") &&
                        p.object_pk == this.dataset.hmd_id
                );
                let perms = [];
                perms.push(...permissions);
                perms.push(...o_permissions);
                return perms.length > 0 ? true : false;
            });
            return groupPermission || [];
        }
    }
};
</script>
